import { prop, sortBy, uniq } from 'ramda';
import type { ComboboxOption } from '@library/components/selects';
import { useGetAllLeaguesQuery } from '@bo-services/leaguesApi';
import { useMemo } from 'react';

export const useCorrelationsDashboard = () => {
  const {
    isLoading,
    isFetching,
    data: leagueData,
    isError: isLeagueError
  } = useGetAllLeaguesQuery();

  const allStatTypes: Array<ComboboxOption> = useMemo(
    () =>
      leagueData
        ? leagueData.included
            .filter(
              (projectionFilter) =>
                projectionFilter.type === 'projection_filter' &&
                projectionFilter.attributes.type === 'StatType'
            )
            .map((filter) => ({
              label: filter.attributes.name,
              value: filter.attributes.name
            }))
        : [],
    [leagueData]
  );

  return {
    allStatTypes: sortBy(prop('value'), uniq(allStatTypes)),
    isLeagueError,
    isLeagueLoading: isLoading || isFetching
  };
};
